export const hostelListData = [
    {
      key: "1",
      id: "H823828",
      hostelName: "Phoenix Residence",
      hostelType: "Boys",
      address: "25 Crowfield Road, Phoenix",
      inTake: "150",
      description: "Rising to nurture young minds",
    },
    {
      key: "2",
      id: "H823827",
      hostelName: "Tranquil Haven",
      hostelType: "Girls",
      address: "81 Hartland Avenue, Milwaukee",
      inTake: "200",
      description: "Rising to nurture young minds",
    },
    {
      key: "3",
      id: "H823826",
      hostelName: "Radiant Towers",
      hostelType: "Boys",
      address: "School Campus",
      inTake: "180",
      description: "Illuminating minds with knowledge and warmth",
    },
    {
      key: "4",
      id: "H823825",
      hostelName: "Nova Nest",
      hostelType: "Girls",
      address: "School Campus",
      inTake: "180",
      description: "A nestling ground for budding intellectuals to thrive",
    },
    {
      key: "5",
      id: "H823824",
      hostelName: "Vista Villat",
      hostelType: "Boys",
      address: "65 Braxton Street, Sheffield",
      inTake: "250",
      description: "Overlooking the vast landscape of knowledge",
    },
    {
      key: "6",
      id: "H823823",
      hostelName: "Zenith Zone",
      hostelType: "Girls",
      address: "School Campus",
      inTake: "150",
      description: "Living at the peak of academic achievement",
    },
    {
      key: "7",
      id: "H823822",
      hostelName: "Summit Springs",
      hostelType: "Boys",
      address: "55 Upton Avenue, Monson",
      inTake: "300",
      description: "Drawing from the wellspring of knowledge",
    },
    {
      key: "8",
      id: "H823821",
      hostelName: "Beacon Breeze",
      hostelType: "Girls",
      address: "School Campus",
      inTake: "280",
      description: "Riding the winds of educational inspiration",
    },
    {
      key: "9",
      id: "H823820",
      hostelName: "Empyrean Estate",
      hostelType: "Boys",
      address: "45 Cinnamon Lane, San Antonio",
      inTake: "200",
      description: "Infusing energy into scholarly endeavors",
    },
    {
      key: "10",
      id: "H823819",
      hostelName: "Nexus Nook",
      hostelType: "Girls",
      address: "School Campus",
      inTake: "350",
      description: "A communal hub for academic excellence",
    },
  ];